import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import conxtdOut from 'apis/conxtdOut';
import ReactTable from "react-table";

import Icon from "components/Icons/Icon";

import TimezoneDate from "components/Common/TimezoneDate.js";
// import Loading from "components/Loading";

import { setAssetId, setSiteAssetViewUid } from "services/redux/actions/serviceDesk";
import { getSiteAssetViewUid } from 'services/redux/selectors/serviceDesk/assets';

import { useIsMounted } from "components/Common/CustomHooks/useIsMounted";
import Axios from '../../../../../../node_modules/axios/index';

export default function AssetLinking({ timezone, setSiteAssetView, setNavSiteViewName, setNavName, scrollToTop }) {

  const dispatch = useDispatch();
  const isMounted = useIsMounted();

  const assetUid = useSelector(getSiteAssetViewUid);

  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const source = Axios.CancelToken.source();

    if (assetUid && isMounted) {
      const getAssetLinkData = conxtdOut.get(`/company-asset-links/linked-assets/${assetUid}`, { cancelToken: source.token })
      getAssetLinkData.then((response) => {
        const data = response?.data;
        const extractedData = Object.values(data)?.flatMap(asset => 
          Object.values(asset).flatMap(category => 
            Object.entries(category).flatMap((subcategory) =>
              Object.values(subcategory)?.map(item => item)?.[1]
            )
          )
        );
        const formattedAssets = extractedData?.map(asset => {
          // format fields
          const fields = Object.values(asset?.fields)?.map(field => ({
            [field?.field_name]: field?.value,
          }));
          const formattedFields = fields.reduce((acc, obj) => {
            for (const [key, value] of Object.entries(obj)) {
              acc[key] = acc[key] ? [].concat(acc[key], value) : value;
            }
            return acc;
          }, {});
          
          // return object of asset info
          let formattedAsset = {
            site_ref: asset?.site?.site_ref,
            category: asset?.asset_name,
            modified: asset?.modified,
            name: formattedFields?.['Name'] || "",
            tag: formattedFields?.['Asset Tag'] || "",
            uid: asset?.asset_uid,
            asset_id: asset?.asset_id,
          }

          return formattedAsset;
        })

        setAssets(formattedAssets);
      })
      .catch((error) => {
        console.log("Error when retrieving Asset Linking data: ", error)
      });
    }

    return () => {
      source.cancel("Component unmounted: request canceled");
    }
  }, [assetUid, setAssets])

  const columns = [
    {
      key: "NAME",
      Header: "Name",
      id: "name",
      minWidth: 150,
      style: {
        textAlign: "left",
        paddingLeft: "10px",
      },
      accessor: data => data.name ?? "N/A",
      Cell: (props) => {
        const index = "Name";
        const value = props.original?.name;
        return (
          <div className='ml-1'>
            {index === 'Name' ?
              <span
                className='site-view-link'
              >
                <Icon className="fas fa-external-link-square-alt mr-2"></Icon>
                <span
                  onClick={() => {
                    setNavSiteViewName(value);
                    setSiteAssetView(true);
                    setNavName(props.original?.category)
                    const assetId = props.original?.asset_id;
                    if (assetId) {
                      dispatch(setAssetId({
                        assetId: assetId,
                        overrideLocal: true,
                      }));
                    }
                    const uid = props.original?.uid;
                    uid && dispatch(setSiteAssetViewUid(uid));
                    scrollToTop();
                  }}
                >
                  {value}
                </span>
              </span>
              :
                value 
              ?? 
                "N/A"
            }
          </div>
        )
      },
    },
    {
      key: "CATEGORY",
      Header: "Category",
      id: "category",
      minWidth: 150,
      style: {
        textAlign: "left",
        paddingLeft: "10px",
      },
      accessor: data => data.category ?? "N/A",
    },
    {
      key: "ASSET_TAG",
      Header: "Asset Tag",
      id: "asset_tag",
      minWidth: 100,
      style: {
        textAlign: "left",
        paddingLeft: "10px",
      },
      accessor: data => data.tag ?? "N/A",
    },
    {
      key: "LAST_MODIFIED",
      Header: "Last Modified",
      id: "Last_modified",
      minWidth: 150,
      filterable: false,
      style: {
        textAlign: "left",
        paddingLeft: "10px",
      },
      accessor: data => {
        const modified = {
          acked: data.modified,
          timezone: timezone,
          format: "HH:mm ddd DD/MM/YYYY",
        }
        return modified ?? "N/A";
      },
      Cell: ({ row }) => {
        const occurrence = row.Last_modified;
        return (
          <TimezoneDate
            date={occurrence.acked}
            timezone={occurrence.timezone} 
            format={occurrence.format} 
            hideTimezone={true}
          />
        )
      },
    },
  ];

  return (
    <>
      <Form.Text className="page-sub-header">Asset Linking</Form.Text>
      <div className='pr-0'>
        <ReactTable
          // ref={r => (this.reactTable = r)}
          columns={columns}
          data={assets}
          // filterable
          // filtered={tableFilters}
          // sortable={assets.length > 0}
          defaultPageSize={10}
          noDataText={'No linked assets found'}
        />
      </div>
    </>
  )
}
